// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__12iDA","radioRow":"SimpleQuestionBuilderModal_radioRow__25kiT"};